import CreditCardIcon from '@mui/icons-material/CreditCard';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import EditIcon from '@mui/icons-material/Edit';
import { Box, IconButton, Paper, styled } from '@mui/material';
import Button from '@mui/material/Button';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { formatMonthNum } from '../../../../utils/timeUtils';
import { getCardIcon, sentenceCase } from '../../../../utils/utils';
import Text from '../../../elements/text/Text';

const StyledCardContainer = styled(Paper)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: '1em',
  [theme.breakpoints.up('sm')]: {
    width: '400px',
  },
  [theme.breakpoints.down('md')]: {
    width: '94%',
  },
}));

const StyledNoCardContainer = styled(Paper)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: '1em',
  [theme.breakpoints.up('sm')]: {
    width: '500px',
  },
  [theme.breakpoints.down('md')]: {
    width: '94%',
    flexDirection: 'column',
    gap: '0.5em',
  },
}));

const StyledTextWrapper = styled('div')(({ theme }) => ({
  flexDirection: 'column',
  marginLeft: theme.spacing(2),
}));

const PaymentCardSection = ({
  card,
  canDelete,
  toggleAddModal,
  toggleUpdateModal,
  toggleDeleteModal,
}) => {
  const { t } = useTranslation();

  return card ? (
    <StyledCardContainer variant="outlined">
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        {getCardIcon(card?.brand, 50)}
        <StyledTextWrapper>
          <Text bodyBold>
            {t('billing.creditCardEnding', {
              ns: 'project',
              number: card.number,
            })}
          </Text>
          <Text caption>
            {t('billing.creditCardExpiration', {
              ns: 'project',
              number: `${formatMonthNum(card.expireMonth)}/${card.expireYear
                .toString()
                .slice(2)}`,
            })}
          </Text>
        </StyledTextWrapper>
      </Box>
      <Box>
        <IconButton onClick={toggleUpdateModal} aria-label="edit" size="large">
          <EditIcon />
        </IconButton>
        <IconButton
          onClick={canDelete ? toggleDeleteModal : toggleAddModal}
          aria-label="delete"
          size="large"
        >
          <DeleteForeverIcon />
        </IconButton>
      </Box>
    </StyledCardContainer>
  ) : (
    <StyledNoCardContainer variant="outlined">
      <Text subtitleBold>
        {sentenceCase(
          t('noFound', {
            ns: 'descriptions',
            text: t('billing.creditCard', { ns: 'project' }),
          })
        )}
      </Text>
      <Button startIcon={<CreditCardIcon />} onClick={toggleAddModal}>
        {t('add', {
          ns: 'buttons',
          text: t('billing.creditCard', { ns: 'project' }),
        })}
      </Button>
    </StyledNoCardContainer>
  );
};

PaymentCardSection.propTypes = {
  card: PropTypes.object,
  canDelete: PropTypes.bool,
  toggleAddModal: PropTypes.func.isRequired,
  toggleUpdateModal: PropTypes.func.isRequired,
  toggleDeleteModal: PropTypes.func.isRequired,
};

export default PaymentCardSection;
